export const MapSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.16663 7.49996C4.16663 4.27496 6.77496 1.66663 9.99996 1.66663C13.225 1.66663 15.8333 4.27496 15.8333 7.49996C15.8333 11.875 9.99996 18.3333 9.99996 18.3333C9.99996 18.3333 4.16663 11.875 4.16663 7.49996ZM7.91663 7.49996C7.91663 8.64996 8.84996 9.58329 9.99996 9.58329C11.15 9.58329 12.0833 8.64996 12.0833 7.49996C12.0833 6.34996 11.15 5.41663 9.99996 5.41663C8.84996 5.41663 7.91663 6.34996 7.91663 7.49996Z"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
